<template>
    <!-- 项目竣工考评结果告知-->
    <div style="height:100%" class="doneResultPublicity" id="cst_doneResultPublicity">
        <!-- 搜索面板 -->
        <search-panel :dirs="dirs_" ref="searchPanel" :searchdata="searchdata" :showBtn="showBtn" :tableCode="table_init.table_code" @passLimit="getLimit"></search-panel>
        <base-table v-loading="loading" element-loading-text="加载中，请稍候" @passcurrentRow="(val)=>{currentRow=val[0].currentRow}" @sortChange="sortChange"
		:tableInit="table_init" tableHeight="auto" @queryItem="queryItem" style="height: 65%;">
        </base-table>
        <pagination @paginationChange="paginationChange" :total="totalPage"></pagination>
    </div>
</template>
<script>
import { doneResultInform } from "@/assets/json.js"
import { API_ProjectCheck ,API_SecSeal } from "@/api/api.js"
import JS_secSeal from "@/tool/secSeal.js"

import searchPanel from "@/components/common/search_panel_new.vue"
import baseTable from "@/components/common/base_table.vue"
import pagination from "@/components/common/pagination.vue"
import detailDialog from "@/components/pages/safetyCheck/cstProject/monthCheckQuery/detail_dialog.vue"
export default {
    props: ['isIndex'],
    data() {
        return {
            loading: true,
            //搜索组件
            searchdata: searchdata,//搜索属性
            showBtn: showBtn,//要展示的搜索按钮
            dirs_:{totalname:totalname_ , finaltrialresult:finaltrialresult_},
            //表格组件
            limit: {},
            table_init: doneResultInform.table_init,
            sort: null,
            order: null,
            currentRow: {},
            totalPage: 0,
            page: 1,
            pageSize: 10,
            //detailDialog
            detailDialog: false,
            isEdit: false,//默认查看详情
        }
    },
    mounted() {
        this.queryAll()
    },
    methods: {
		queryItem(row){
			this.currentRow = row;
			// 查看电子签章
			JS_secSeal.onload(this,true); //连接websocket
			API_SecSeal.getList("20/1",{ limit: {recordId:this.currentRow.id , code:"SGXMKP009" , tableName:"hy_safety_projectfinishedevalsp"} }).then(res => {
				if (res.total > 0) {
					JS_secSeal.viewSeal(res.data[0].filepath , (res.data[0].type ? res.data[0].type === "getFromSupervisorEnd" : false),true);
				} else {
					this.$alert("没有找到签章文件！", "错误", {
                        confirmButtonText: "确定",
                        type: "error"
                    })
					return false;
				}
            });
		},
        getLimit(params) {
            switch (params[0]) {
                case "queryAll":
                    {
                        let t_limit = params[1];
                        let limit = {};
                        for (var i in t_limit) {
                                if (t_limit[i] && t_limit[i].length > 0) {
                                    limit[i] = t_limit[i];
                                }
                        }
                        this.limit = limit;
                    }
                    this.queryAll();
                    break;
            }
        },
        sortChange(param) {
           if (param.order != null) {
				this.order = param.order.indexOf("asc") > -1 ? "asc" : "desc";
				this.sort = param.prop;
			} else {
				this.order = null
				this.sort = null
			}
			this.queryAll();
        },
        paginationChange(param) {
            this.pageSize = param[0];
            this.page = param[1];
            this.queryAll();
        },
        closeDialog(dialogName) {
            this.detailDialog = false;
        },
        queryAll() {
            this.table_init.body = [];
            this.loading = true;
            let limit = {};
            let userinfo = JSON.parse(localStorage.userinfo);
            for (let i in this.limit) { limit[i] = this.limit[i]; }
            limit["otype"] = "2";
            if (this.sort != null)
				limit[this.sort + "_order"] = this.order;
            if (this.isIndex) {
                API_ProjectCheck.homeListFinishedInform( this.pageSize + "/" + this.page, { limit: limit }).then(res => {
                    this.table_init.body = res.resultList;
                    this.totalPage = res.count;
                    this.loading = false;
                })
            }
            else {
                API_ProjectCheck.listFinishedInform(this.pageSize + "/" + this.page, { limit: limit }).then(res => {
                    this.table_init.body = res.data;
                    this.totalPage = res.total;
                    this.loading = false;
                })
            }
        },
    },
    components: { searchPanel, baseTable, pagination, detailDialog }
}
const showBtn = [
    { "label": "搜索", attr: "queryAll" },
]
const searchdata = [
    { name: "项目名称", attr: "proname_like", type: "text", isRange: false, "dictionary": "" },
    { name: "所在地市", attr: "totalname", type: "select", isRange: false, "dictionary": "totalname" },
    { name: "考评结果", attr: "finaltrialresult", type: "select", isRange: false, "dictionary": "finaltrialresult" },
    { name: "施工企业名称", attr: "conunitmc_like", type: "text", isRange: false, "dictionary": "curmonth" },
    { name: "告知书编号	", attr: "informbh", type: "text", isRange: false, },
]
const totalname_ = [{ name: "全部", code: "" }, { name: "福州市", code: "福州市" }, { name: "厦门市", code: "厦门市" }, { name: "泉州市", code: "泉州市" },
{ name: "漳州市", code: "漳州市" }, { name: "莆田市", code: "莆田市" }, { name: "宁德市", code: "宁德市" }, { name: "龙岩市", code: "龙岩市" },
{ name: "三明市", code: "三明市" }, { name: "南平市", code: "南平市" }, { name: "平潭综合实验区", code: "平潭综合实验区" }]
const finaltrialresult_ = [{ name: "全部", code: "" }, { name: "合格", code: "合格" }, { name: "不合格", code: "不合格" },];

</script>



// WEBPACK FOOTER //
// doneResultInform.vue?a9b9d6fe